import { useMutation, useQueryClient } from 'react-query';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import cogoToast from 'cogo-toast';
import { getUsePartiesQKey } from '../../overview/api/getParties';
import { useTranslation } from 'react-i18next';
import { PartyType } from '../../../../../../types/SMT';
import { RiskObjectRevisions } from '../../../../../../types/Broker';
import { Party } from '../../../types';

interface PostPartyParams {
  type: PartyType;
  payload: Partial<Party>;
}

interface Response {
  id: string;
  risk_object_revisions: RiskObjectRevisions;
}

export const postParty = async ({ type, payload }: PostPartyParams) => {
  /** API routes are 'companies' & 'customer' */
  const apiType = type === 'COMPANY' ? 'companies' : 'customers';
  const path = `v1/api/parties/${apiType}`;
  const { data, isError } = await wgApi.post<Response>(path, payload);
  if (isError) throw new Error();
  return data;
};

export const usePostParty = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation(postParty, {
    onError: () => {
      cogoToast.error(t('PORTFOLIO_PARTY-CREATION_TOAST_FAILURE'), {
        hideAfter: 5,
      });
    },
    onSettled: () => {
      const queryKey = getUsePartiesQKey();
      queryClient.invalidateQueries(queryKey);
    },
  });
};
